// where input and error are
// js selectors like
// const input = document.querySelector('.js-input-field');
// const error = document.querySelector('.js-error-sign');

function validatePassword(input, error) {
    const password = input.value.trim();
    // if (password === '') {
    //     showErrorMessage(passwordError, 'Please enter a password.');
    //     return false;
    // }

    if (password.length < 8
        || !/[A-Z]/.test(password) // at least one uppercase letter
        || !/[0-9]/.test(password) // at least on number
        || !/[^a-zA-Z0-9]/.test(password) // at least on special character
    ) {
        showErrorMessage(error, 'At least 8 characters, including numbers, symbols, 1 lowercase, and 1 uppercase letter.');
        return false;
    }

    hideErrorMessage(error);
    return true;
}

function showErrorMessage(element, message) {
    $(element).text(message);
    $(element).addClass('active c-alert');
    $(element).siblings('.form-item-wrap').addClass('error')
    .find('.form-item').addClass('error');
}

function hideErrorMessage(element) {
    ($(element).hasClass('js-create-new-password-sign') || $(element).hasClass('js-signup-password-sign'))
    ? $(element).removeClass('c-alert').addClass('active c-gray-5')
    : $(element).removeClass('active c-alert');

    $(element).siblings('.form-item-wrap').removeClass('error').addClass('success')
    .find('.form-item').removeClass('error');
}
